import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";
import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ModifyDisplayName: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {
	
	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const {
		toast,
	} = useContext(UIContext);  

	const [title, setTitle] = useState("");

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		}	
		
	}, []);


	const handleSubmit = async () => {
		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/displayname`, {
			displayName: title
		});

		if (res_info.code === 1000) {
			
			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');
		} else if (res_info.code === 4000) {
			
			toast ({
				type: 'warning', 
				contents: "중복된 닉네임으로 다른 닉네임으로 설정해 주세요"
			});
		}
	};
	
	const handleCancel = () => {
		navigate(-1);
	};

	const handleBack = () => {
		navigate(-1);
	}

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
						>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									닉네임 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />
						
						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 닉네임을 입력해주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								현재 등록된 닉네임은 [{initData.userInfo.displayName}]이에요.
							</span>
						</div>

						<div className="mt-10" />

						<Input
							className="mt-10"
							value={title}
							onChange={e => setTitle(e.target.value)}
						/>

						
						<div className="w-full border-b border-neutral-100 dark:border-neutral-800 mt-10"></div>
						

						<div className="flex flex-col mt-3 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							<ButtonSecondary
								onClick={() => handleCancel()}
							>
								취소
							</ButtonSecondary>
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>						

						

					</div>

				</div>
				
			</div>
		</>
	);
};

export default ModifyDisplayName;
